import gql from "graphql-tag";

export const CHECK_DEAL = gql`
  query checkDeal($name: String!, $business_profile_id: uuid!) {
    deals_count: deals_aggregate(
      where: {
        name: { _eq: $name }
        business_profile_id: { _eq: $business_profile_id }
        expire_date_time: { _gt: "now()" }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
